<template>
  <div class="meeting-bill-list">
    <el-container>
      <el-header style="padding: 0">
        <!-- 查询 -->
        <el-form
          :model="queryForm"
          :inline="true"
          label-width="100px"
          style="padding-right: 20px"
        >
          <el-row>
            <el-col :span="6">
              <el-form-item label="提报部门：" label-width="80px">
                <el-input
                  v-model="queryForm.reportDepartmentName"
                  placeholder="-请输入-"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="项目分类：" label-width="80px">
                <el-select
                  v-model="queryForm.projectType"
                  placeholder="-请选择-"
                  clearable
                >
                  <!-- 注意：后台返回，显示用value字段，传参用label字段 -->
                  <el-option
                    v-for="option in projectTypeList"
                    :key="option.id"
                    :label="option.value"
                    :value="option.label"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="会议议题：" label-width="80px">
                <el-input
                  v-model="queryForm.subject"
                  placeholder="-请输入-"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <template v-if="showAdvanceFilter">
              <el-col :span="6">
                <el-form-item label="提报日期：" label-width="80px">
                  <el-date-picker
                    v-model="queryForm.submitDate"
                    value-format="yyyy-MM-dd"
                    type="date"
                    placeholder="-请选择-"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="申请人：" label-width="80px">
                  <el-input
                    v-model="queryForm.whoSubmit"
                    placeholder="-请输入-"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="申请部门：" label-width="80px">
                  <el-input
                    v-model="queryForm.applyDepartmentName"
                    placeholder="-请输入-"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="是否上会：" label-width="80px">
                  <el-select
                    v-model="queryForm.isOn"
                    placeholder="-请选择-"
                    clearable
                  >
                  <el-option
                  :label="item.label"
                  :value="item.value"
                  v-for="(item, index) in options"
                  :key="index"
                ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </template>
            <el-col :span="6">
              <!-- 其他页有时候会设成12，是因为按钮分出的部分 -->
              <el-form-item>
                <div class="search-btns">
                  <el-button type="primary" icon @click="handleSearch"
                    >查询</el-button
                  >
                  <el-button type="info" icon @click="resetSearch"
                    >重置</el-button
                  >
                  <el-button type="text" @click="toggleAdvance">{{
                    showAdvanceFilter ? "收起" : "高级筛选"
                  }}</el-button>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-col :span="24" style="padding: 0 20px">
          <div class="operatePanel">
            <el-button
              type="primary"
              icon="el-icon-plus"
              @click="createMeetingBill"
              v-if="btnAuthorize.addBtn.btnEnable"
              >新增</el-button
            >
            <el-button
              type="primary"
              icon="el-icon-edit"
              @click="editMeetingBill"
              v-if="btnAuthorize.modifyBtn.btnEnable"
              >修改</el-button
            >
            <el-button
              type="primary"
              icon="el-icon-edit"
              @click="upMeetingSetFun"
              v-if="isZongheban == 1"
              >上会设置</el-button
            >
            <el-button
              type="primary"
              icon="el-icon-delete"
              @click="deleteMeetingBill"
              v-if="btnAuthorize.delBtn.btnEnable"
              >删除</el-button
            >
            <el-button
              type="primary"
              icon="el-icon-refresh-left"
              @click="callbackMeetingBill"
              v-if="btnAuthorize.callback.btnEnable"
              >撤回</el-button
            >
            <el-button
              type="primary"
              icon="el-icon-printer"
              @click="printMeetingBill"
              v-if="btnAuthorize.print.btnEnable"
              >打印</el-button
            >
          </div>
        </el-col>
      </el-header>
      <el-main>
        <el-table
          ref="multipleTable"
          :data="tableData"
          border
          size="mini"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          @row-click="rowClicked"
          @cell-dblclick="gotoDetail"
        >
          <el-table-column type="selection" width="54"></el-table-column>
          <el-table-column
            v-for="(item, index) in tableColumnDatas"
            :key="index"
            :prop="item.class"
            :label="item.labelName"
            :min-width="item.minWidth"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="出席人"
            show-overflow-tooltip
            min-width="200px"
          >
            <!-- joinWorkJson -->
            <!-- joinWorkList -->
            <template slot-scope="scope">
              <span v-for="(item, index) in scope.row.joinWorkList" :key="index"
                >{{ item.displayName || item.name }}&nbsp;</span
              >
            </template>
          </el-table-column>
          <el-table-column
            label="参会部门"
            show-overflow-tooltip
            min-width="200px"
          >
            <!-- checkWorkJson -->
            <!-- checkWorkList -->
            <template slot-scope="scope">
              <span
                v-for="(item, index) in scope.row.checkWorkList"
                :key="index"
                >{{ item.name }}&nbsp;</span
              >
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer>
        <div style="display: flex; justify-content: space-between">
          <span
            style="
              color: #666666;
              font-size: 14px;
              line-height: 32px;
              margin-top: 16px;
            "
            >显示{{
              totalCount > 0
                ? (currentPage - 1) * pageSize +
                  1 +
                  "-" +
                  (currentPage * pageSize > totalCount
                    ? totalCount
                    : currentPage * pageSize)
                : "0"
            }}，共{{ totalCount }}条记录</span
          >
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
          ></el-pagination>
        </div>
      </el-footer>
      <!-- 快捷审批弹出框 -->
      <el-dialog title="审批" :visible.sync="dialogApproveVisible">
        <el-form
          ref="approveDialogForm"
          :model="approveFormData"
          label-width="100px"
          :rules="approveDialogRules"
        >
          <el-form-item label="会议议题">
            <el-input :value="approveFormData.title" readonly></el-input>
          </el-form-item>
          <el-form-item label="提报部门">
            <el-input :value="approveFormData.deptName" readonly></el-input>
          </el-form-item>
          <el-form-item label="项目分类">
            <el-input
              :value="approveFormData.projectTypeValue"
              readonly
            ></el-input>
          </el-form-item>
          <el-form-item label="审批意见" prop="opinion">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="-请输入-"
              maxlength="100"
              show-word-limit
              v-model="approveFormData.opinion"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button type="info" @click="rejectApproveDialog">驳回</el-button>
          <el-button type="primary" @click="submitApproveDialog"
            >通过</el-button
          >
        </div>
      </el-dialog>
      <MeetingOrderPrint
        :visible.sync="dialogPrintVisible"
        :printData="meettingOrderData"
        v-if="dialogPrintVisible"
      >
      </MeetingOrderPrint>
      <!--上会设置-->
      <upMeetingSet
        :visible="upMeetingSetVisible"
        :id='selectItems'
        @handleChange="handleChange"
        v-if="upMeetingSetVisible"
      >
      </upMeetingSet>
    </el-container>
  </div>
</template>

<script>
import {
  getDeclarationList,
  getProjectTypeList,
  deleteDeclaration,
  queryApproveProcess,
  submitApproveProcess,
  recallDeclaration,
  getDeclarationDetail,
} from "@/services/declarationServices";
import { getSign } from "@/services/basicDataService";
import { getOtherConferenceTypeList } from "@/services/conferenceServices";
import { getDeptListService } from "@/services/sysSettingService";
import { getSubService } from "@/services/departService";
import Consts from "@/utils/consts";
import { tabIndex, getTabIndexParam } from "./variables";
import MeetingOrderPrint from "./components/MeetingOrderPrint";
import upMeetingSet from "./components/upMeetingSet";

export default {
  name: "MeetingBillList",
  components: {
    MeetingOrderPrint,
    upMeetingSet,
  },
  data() {
    return {
      btnAuthorize: {
        addBtn: { key: "create", btnEnable: false },
        modifyBtn: { key: "update", btnEnable: false },
        delBtn: { key: "delete", btnEnable: false },
        approve: { key: "approve", btnEnable: false }, //审核
        callback: { key: "callback", btnEnable: false }, //撤回
        print: { key: "print", btnEnable: false }, // 打印
        upMeetingSetBtn: { key: "upMeetingbtn", btnEnable: true }, // 上会设置
      },
      meetingTypeList: [],
      master1Sign: "",
      master2Sign: "",
      // 打印时的数据
      dialogPrintVisible: false,
      upMeetingSetVisible: false,
      meettingOrderData: {}, //会议提报单需要打印数据
      printTitle: "", //主题
      printContent: "", // 会议主要内容
      printDeptName: "", // 汇报部门
      printReportUserName: "", // 汇报人
      printPeople: [], // 审批人
      printTypeName: "", //  会议类型
      printJoinWorkList: [], //出席人
      printCheckWorkList: [], // 参会部门
      isZongheban: sessionStorage.getItem('isZongheban'),
      dialogApproveVisible: false,
      approveFormData: {},
      approveDialogRules: {
        approveOpinion: [
          { required: true, message: "请输入审核意见", trigger: "blur" },
        ],
      },
      tabIndex: tabIndex,
      showAdvanceFilter: false, // 高级筛选
      activeName: "first",
      queryForm: {
        // 查询参数
        reportDepartment: null, //提报部门
        reportDepartmentName: "", // 提报部门
        projectType: "", //项目分类,传参时是个字符串
        subject: "", // 会议议题
        submitDate: null, // 提报日期
        whoSubmit: "", // 申请人
        applyDepartmentName: "", // 申请部门名字，模糊查询
        applyDepartment: null, // 申请部门
        isOn: "", // 是否上会，默认为空，就查出来所有的
      },
      options: [
        {
          label: "未上会",
          value: '0',
        },
        {
          label: "已上会",
          value: '1',
        },{
          label: "无需上会",
          value: '2',
        },
        {
          label: "驳回",
          value: '3',
        },
      ],
      projectTypeList: [], //项目分类
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      tableData: [], // 返回的列表数据
      tableColumnDatas: [
        // { class: "id", labelName: "ID" },
        { class: "deptName", labelName: "提报部门" },
        { class: "projectTypeValue", labelName: "项目分类" },
        { class: "title", labelName: "会议议题", minWidth: "200px" },
        { class: "createTime", labelName: "提报日期", minWidth: "200px" },
        { class: "applyUserName", labelName: "申请人" },
        { class: "operatorDeptName", labelName: "申请部门" },
        {
          class: "approveStatusName",
          labelName: "审核状态",
          sortEnable: false,
        },
        { class: "onMeetingLabel", labelName: "是否上会" },
        { class: "submitDesc", labelName: "上会说明" },
      ],
      selectItems: [],
      orgId: null, // 当前人所在的组织id
      currentUserId: null, // 当前这个人的id
      cascaderProps: {
        // 提报部门的选择
        checkStrictly: true,
        lazy: true,
        label: "name",
        value: "id",
        lazyLoad: (node, resolve) => {
          //  在这个加载方法里处理error，如果想用vue的this绑定，必须用箭头函数保持this指向。用function的写法会重新绑定this指向
          let { level } = node;
          if (level == 0) {
            // 第1级，用当前人的orgId去获取组织下的部门列表
            getDeptListService({
              pid: 0,
              orgId: sessionStorage.getItem("orgId"), // 它这套打开的逻辑打乱了原有的生命周期，执行顺序，调用lazyLoad时还没有调用onActive
            })
              .then((res) => {
                if (res.code == Consts.Code_OK) {
                  let nodes = res.data || [];
                  nodes.forEach((node) => {
                    node.leaf = node.isLeaf == 1;
                  });
                  return resolve(nodes);
                } else if (res.code >= Consts.Code_Err) {
                  this.$alert(res.msg, "提示", {
                    confirmButtonText: "确定",
                  });
                } else {
                  this.$message.error(res.Msg);
                  resolve([]);
                }
              })
              .catch((error) => {
                this.$message.error(Consts.Err_Msg);
                resolve([]);
              });
          } else {
            // 用选择的node去获取对应的子部门
            getSubService({
              deptId: node.data.id,
            })
              .then((res) => {
                if (res.code == Consts.Code_OK) {
                  let nodes = res.data || [];
                  nodes.forEach((node) => {
                    node.leaf = node.isLeaf == 1;
                  });
                  return resolve(nodes);
                } else if (res.code >= Consts.Code_Err) {
                  this.$alert(res.msg, "提示", {
                    confirmButtonText: "确定",
                  });
                } else {
                  this.$message.error(res.Msg);
                  resolve([]);
                }
              })
              .catch((error) => {
                this.$message.error(Consts.Err_Msg);
                resolve([]);
              });
          }
        },
      },
      cascaderProps2: {
        // 申请部门的选择
        checkStrictly: true,
        lazy: true,
        label: "name",
        value: "id",
        lazyLoad: (node, resolve) => {
          let { level } = node;
          if (level == 0) {
            getDeptListService({
              pid: 0,
              orgId: sessionStorage.getItem("orgId"),
            })
              .then((res) => {
                if (res.code == Consts.Code_OK) {
                  let nodes = res.data || [];
                  nodes.forEach((node) => {
                    node.leaf = node.isLeaf == 1;
                  });
                  return resolve(nodes);
                } else if (res.code >= Consts.Code_Err) {
                  this.$alert(res.msg, "提示", {
                    confirmButtonText: "确定",
                  });
                } else {
                  this.$message.error(res.Msg);
                  resolve([]);
                }
              })
              .catch((error) => {
                this.$message.error(Consts.Err_Msg);
                resolve([]);
              });
          } else {
            getSubService({
              deptId: node.data.id,
            })
              .then((res) => {
                if (res.code == Consts.Code_OK) {
                  let nodes = res.data || [];
                  nodes.forEach((node) => {
                    node.leaf = node.isLeaf == 1;
                  });
                  return resolve(nodes);
                } else if (res.code >= Consts.Code_Err) {
                  this.$alert(res.msg, "提示", {
                    confirmButtonText: "确定",
                  });
                } else {
                  this.$message.error(res.Msg);
                  resolve([]);
                }
              })
              .catch((error) => {
                this.$message.error(Consts.Err_Msg);
                resolve([]);
              });
          }
        },
      },
    };
  },

  mounted() {
    getOtherConferenceTypeList()
      .then((res) => {
        if (res.code == Consts.Code_OK) {
          let list = res.data || [];
          // this.meetingTypeList = list;
          this.meetingTypeList = list.filter((item) => item.label != "zthy");
        }
      })
      .catch((error) => {});
  },

  methods: {
    // 打印
    printMeetingBill() {
      if (!this.selectItems || this.selectItems.length == 0) {
        this.$alert(Consts.No_Select_Tip, "提示");
        return;
      }
      if (this.selectItems.length > 1) {
        this.$alert(Consts.One_Select_Tip, "提示");
        return;
      }
      //如果已经保存过会议提报单

      let target = this.selectItems[0];
      getDeclarationDetail({ id: target.id })
        .then((res) => {
          if (res.code == Consts.Code_OK) {
            if (!res.data.declarationPrintVO) {
              this.$confirm("请先新建会议提报单", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "info",
              })
                .then(() => {
                  //跳转新建会议提报单页面
                  this.gotoDetail(this.selectItems[0]);
                })
                .catch(() => {});
              return;
            }
            const data = res.data.declarationPrintVO || {};
            const approveInfoList = data.approveInfoList?.slice() ?? [];
            //  approveInfoList.unshift({
            //         approveUserId: approveInfoList[0]?.approveUserId ?? "",
            //         approveUserName: approveInfoList[0]?.approveUserName ?? "",
            //         approveUserNameSignUrl:
            //           approveInfoList[0]?.approveUserNameSignUrl ?? null,
            //         deptKey: approveInfoList[0]?.deptKey ?? "",
            //         deptKeyName: "参会部门负责人意见",
            //         isPrint: true,
            //         opinion: approveInfoList[0]?.opinion ?? "",
            //       });
            this.meettingOrderData = {
              ...data,
              approveInfoList,
              operatorDeptName: res.data.operatorDeptName,
              title: res.data.title,
              content: res.data.content,
            };
            if (res.data.checkWorkJson) {
              console.log(JSON.parse(res.data.checkWorkJson));
              this.meettingOrderData.checkWorkList = JSON.parse(
                res.data.checkWorkJson
              )
                .map((e) => e.name)
                .join("、");
            }
            // this.meettingOrderData=res.data
            // this.meettingOrderData.approveInfoList=itemApproveProcessVOs

            // 获取签名
            // this.printPeople.forEach((item) => {
            //   if (item.status != 99) {
            //     getSign({ signUserId: item.approveUserId })
            //       .then((res) => {
            //         if (res.code == Consts.Code_OK) {
            //           this.$set(this, `master${item.sort}Sign`, res.data);
            //           console.log("签名，", item.sort, res.data);
            //         } else {
            //           console.log("获取签名失败", item, res.msg);
            //         }
            //       })
            //       .catch((error) => {
            //         console.log("获取签名失败", item, error);
            //       });
            //   }
            // });

            // this.$nextTick(() => {
            //   this.dialogPrintVisible = true;
            // });
            this.dialogPrintVisible = true;
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //上会设置
    upMeetingSetFun() {
      if (!this.selectItems || this.selectItems.length == 0) {
        this.$alert(Consts.No_Select_Tip, "提示");
        return;
      }
      // if (this.selectItems.length > 1) {
      //   this.$alert(Consts.One_Select_Tip, "提示");
      //   return;
      // }
      // for(let i=0;i<this.selectItems.length;i++)
      // {
      //   if (this.selectItems[i].isSubmitted=='已上会') {
      //   this.$alert('已上会会议提报不允许修改上会状态', "提示");
      //   return;
      // }
      // }
      
      this.upMeetingSetVisible = true;
    },
    //关闭上会设置弹窗
    handleChange(val){
      if(val)
      this.getList()
      this.upMeetingSetVisible = false;
    },
    reportDepartmentChange(data) {
      console.log("选中change", data);
    },
    resetApproveForm() {
      this.dialogApproveVisible = false;
      this.$refs.approveDialogForm.resetFields();
    },
    rejectApproveDialog() {
      // 驳回
      this.doApproveSubmit(4);
    },
    submitApproveDialog() {
      // 通过
      this.doApproveSubmit(3);
    },
    doApproveSubmit(status) {
      this.$refs.approveDialogForm.validate((valid) => {
        if (valid == false) {
          return false;
        }
        this.approveFormData.status = status;
        submitApproveProcess(this.approveFormData)
          .then((res) => {
            if (res.code == Consts.Code_OK) {
              this.$alert(Consts.Ok_Msg, "提示");
              this.resetApproveForm();
              this.$nextTick(() => {
                this.getList();
              });
            } else {
              this.$alert(res.msg, "提示");
            }
          })
          .catch((error) => {
            this.$alert(error.message || error, "提示");
          });
      });
    },

    // 审批
    approveMeetintBill() {
      if (!this.selectItems || this.selectItems.length == 0) {
        this.$alert(Consts.No_Select_Tip, "提示");
        return;
      }
      if (this.selectItems.length != 1) {
        this.$alert(Consts.One_Select_Tip, "提示");
        return;
      }
      let approveTarget = this.selectItems[0];
      let { id } = approveTarget;
      queryApproveProcess({
        approveUserId: sessionStorage.getItem("currentUserId"),
        id: id,
      })
        .then((res) => {
          if (res.code == Consts.Code_OK) {
            this.approveFormData = { ...res.data };
            this.approveFormData.title = approveTarget.title;
            this.approveFormData.projectTypeValue =
              approveTarget.projectTypeValue;
            this.approveFormData.opinion = "";
            this.approveFormData.itemId = id; // 后面提交的时候需要
            this.dialogApproveVisible = true;
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch((error) => {
          this.$alert(error.message || error, "错误");
        });
    },

    onActive(menuCode) {
      // console.log('list on active');
      this.activeName = "first";
      this.orgId = sessionStorage.getItem("orgId");
      this.currentUserId = sessionStorage.getItem("currentUserId");
      this.$getRoleBtns(menuCode, this.btnAuthorize);
      this.currentPage = 1;
      this.getList();
      this.initProjectTypeList();
    },

    // 获取初始列表
    getList() {
      let params = {
        deptName: this.queryForm.reportDepartmentName,
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        tabIndex: getTabIndexParam(this.activeName), // 全部0待审核1通过2拒绝3
        title: this.queryForm.subject, // 会议议题
        projectType: this.queryForm.projectType, // 项目分类
        applyUserName: this.queryForm.whoSubmit, // 申请人
        operatorDeptName: this.queryForm.applyDepartmentName, // 申请部门
        submitStatus:this.queryForm.isOn
      };

      if (this.queryForm.submitDate) {
        params.createTime = this.queryForm.submitDate;
      }

      getDeclarationList(params)
        .then((res) => {
          if (res.code == Consts.Code_OK) {
            let list = res.data || [];
            list.forEach((item) => {
              let { joinWorkJson, checkWorkJson } = item;
              try {
                item.joinWorkList = JSON.parse(joinWorkJson);
                item.checkWorkList = JSON.parse(checkWorkJson);
                item.onMeeting = item.approveStatus == 5;
                // item.onMeetingLabel = item.onMeeting ? "已上会" : "未上会"; //  是否上会.5就是已上会，其余状态下都是未上会
                item.onMeetingLabel = item.isSubmitted || "";
              } catch (error) {
                console.log("解析出错");
              }
            });
            this.tableData = list;
            this.totalCount = res.total || 0;
          } else if (res.code >= Consts.Code_Err) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((error) => {
          this.$message.error(Consts.Err_Msg);
        });
    },
    initProjectTypeList() {
      getProjectTypeList()
        .then((res) => {
          if (res.code == Consts.Code_OK) {
            this.projectTypeList = res.data || [];
          } else if (res.code >= Consts.Code_Err) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$message.error(res.Msg);
          }
        })
        .catch((error) => {
          this.$message.error(Consts.Err_Msg);
        });
    },

    handleTabClick(tab) {
      // 因为是v-model，点击之后就自动切换activeName了
      this.currentPage = 1;
      this.getList();
    },
    toggleAdvance() {
      this.showAdvanceFilter = !this.showAdvanceFilter;
    },
    handleSearch() {
      this.currentPage = 1; // 点击查询按钮应该从第1页开始查
      this.getList();
    },
    // 重置
    resetSearch() {
      //重置所有的参数
      this.queryForm = {
        reportDepartment: null,
        reportDepartmentName: "",
        projectType: "",
        subject: "",
        submitDate: null,
        whoSubmit: "",
        applyDepartmentName: "",
        applyDepartment: null,
        isOn: "",
      };
      this.getList();
    },
    // 点击创建新的提报单
    createMeetingBill() {
      this.bus.$emit("navMenuChange", {
        routeId: "createMeetingBill",
        routeParam: {
          openFlag: false,
        },
      });
    },

    editMeetingBill() {
      // 修改
      if (!this.selectItems || this.selectItems.length == 0) {
        this.$alert(Consts.No_Select_Tip, "提示");
        return;
      }
      if (this.selectItems.length > 1) {
        this.$alert(Consts.One_Select_Tip, "提示");
        return;
      }
      let target = this.selectItems[0];

      let { approveStatus, id, applyUserId, status } = target;

      let userId = sessionStorage.getItem("currentUserId");
      let isMyself =
        userId == applyUserId &&
        (approveStatus == 4 || approveStatus == 1 || approveStatus == -1);
      if (isMyself) {
        // 只有自己发的提报单才能修改
        // 被拒绝、已撤回、草稿状态，可以修改
        // 进入修改页
        this.bus.$emit("navMenuChange", {
          routeId: "meetingBillEdit",
          routeParam: {
            id: id,
          },
        });
      } else {
        this.$alert("该提报单不能修改", "提示");
      }
    },

    deleteMeetingBill() {
      // 删除提报单
      if (!this.selectItems || this.selectItems.length == 0) {
        this.$alert(Consts.No_Select_Tip, "提示");
        return;
      }

      this.$confirm(Consts.Delete_Tip, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = [];
          this.selectItems.forEach((item) => {
            ids.push(item.id);
          });
          return deleteDeclaration({ delIds: ids.join(",") });
        })
        .then((res) => {
          if (res.code == Consts.Code_OK) {
            this.$alert(Consts.Ok_Msg, "提示");
            this.$nextTick(() => {
              // 重新刷一遍列表
              // 这里会有问题，比如最后面的页，删除完后刷新列表，如果不重置为1，就有可能拿不回数据了，可能会出错。
              // 重置为1，又不方便继续操作
              // this.currentPage = 1;
              this.getList();
            });
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch((error) => {
          // 这里的error可能是几种类型，false-取消，Error-中途出错，string-后台返回的错误
          if (error instanceof Error) {
            this.$alert(error.message, "提示");
          }
          if (error instanceof String) {
            this.$alert(error, "提示");
          }
        });
    },

    // 撤回
    callbackMeetingBill() {
      if (!this.selectItems || this.selectItems.length == 0) {
        this.$alert(Consts.No_Select_Tip, "提示");
        return;
      }
      if (this.selectItems.length > 1) {
        this.$alert(Consts.One_Select_Tip, "提示");
        return;
      }

      this.$confirm("您确定要撤回选定的提报单吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let target = this.selectItems[0];
          return recallDeclaration({ itemId: target.id, type: "DECLARATION" });
        })
        .then((res) => {
          if (res.code == Consts.Code_OK) {
            this.$alert(Consts.Ok_Msg, "提示");
            // 撤回成功后，刷新一下当前页码的数据。
            // 省点的就是修改单条提报单的数据，重新获取的好处就是能获取全部的最新数据。
            this.getList();
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.currentPage = 1;
      this.getList();
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //选择列表
    handleSelectionChange(val) {
      this.selectItems = val;
    },
    // 点击选中行
    rowClicked(row, event, column) {
      this.$refs.multipleTable.toggleRowSelection(row);
    },
    gotoDetail(row, column, cell, event) {
      this.bus.$emit("navMenuChange", {
        routeId: "meetingBillDetailView",
        routeParam: {
          id: row.id,
          openFlag: false,
          onMeetingbtn:this.btnAuthorize.upMeetingSetBtn.btnEnable,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/commonLayout.scss";

.meeting-bill-list {
  background-color: white;
}

/deep/.el-tabs__header {
  padding-right: 0 !important;
  background: #d5e7ed !important;
}
/deep/ .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  background: #fff;
  color: #069dbc !important;
  border-bottom-color: #e4e7ed;
}
/deep/.el-tabs__item:hover {
  color: #069dbc;
}

.search-btns {
  text-align: right;
}

.el-main {
  min-height: 200px;
  height: auto !important;
}
</style>
